<template>
  <div class="produto-cdlsaude-resumo">
    <div class="content">
      <div class="row">
        <div class="col-6 p-4">
          <Titulo
            title="Resumo"
            description="Confira todos os dados antes de enviar para a conferência."
          />
        </div>
      </div>
      <DadosVidaResumo :dados="titular" />
      <DadosVidaResumo
        class="mt-4"
        v-for="(dependente, index) in dependentes"
        :key="index"
        :dados="dependente"
      />
      <div class="mt-4 bg-white rounded p-4">
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-12 px-3">
            <div class="alert alert-warning">
              O valor da pro-rata será calculado na tela de pagamento conforme a
              data vigência informada.
            </div>
          </div>
        </div>
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-3">
            <FormulateInput
              class="border rounded p-2"
              label="Vigência a partir de:"
              type="date"
              v-model="dataVigencia"
              name="Data de Vigência"
              placeholder="Data Vigência"
              :validation="`required|after:${dataValidation}`"
              :min="dataMinVigencia"
            />
          </div>
          <div class="col-md-8 col-lg-9 text-center text-md-right mb-3 mb-md-0">
            <div class="mb-2">Valor total mensal:</div>
            <div class="">
              <strong class="h3 font-weight-bold text-primary">{{
                totalMensalidade | currency
              }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/produto/cdl-consultor/cdl-saude-finalizar-cadastro"
            name-class="btn btn-outline-secondary btn-lg btn-block"
          >
            Voltar
          </Botao>
        </div>
        <div class="col-md-5 col-lg-4">
          <Botao
            title="Próximo"
            @click="salvarApi"
            name-class="btn btn-cta btn-lg btn-block font-weight-bold"
          >
            PRÓXIMO
          </Botao>
        </div>
      </div>
      <div class="py-5"></div>
    </div>
  </div>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import DadosVidaResumo from "@/components/resumo/DadosVidaResumo";
import { clearStr } from "../../../helpers";
export default {
  name: "ListaVidas",
  components: { Titulo, Botao, DadosVidaResumo },
  data() {
    return {
      disable: false,
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Resumo",
          id: "resumo",
        },
      ],
      registros: [],
      totalMensalidade: 0,
      dataVigencia: null,
      dataMinVigencia: null,
      dataValidation: null,
    };
  },
  computed: {
    titular() {
      const titular = this.registros.filter(
        (r) => r.tipoCadastro === "titular" && r.nome
      );
      return titular.length ? titular[0] : false;
    },
    dependentes() {
      return this.registros.filter(
        (r) => r.tipoCadastro === "dependente" && r.nome
      );
    },
  },
  methods: {
    montaDados() {
      this.registros = JSON.parse(localStorage.getItem("cdlsaude_cadastro"));
      this.totalMensalidade = localStorage.getItem("totalMensalidade");

      const titular = this.registros.filter(
        (r) => r.tipoCadastro === "titular"
      );
      this.cpfTitular = titular[0].cadastroFinal.cpf;

      const date = new Date();
      date.setDate(date.getDate() + 8);

      this.dataMinVigencia =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      date.setDate(date.getDate() - 1);
      this.dataValidation =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      this.dataVigencia = this.dataMinVigencia;
    },
    async salvarApi() {
      for (const [i, registro] of this.registros.entries()) {
        if (!registro.cadastrado && registro.nome) {
          var result = this.prepararDados(registro);
          await this.$http
            .post("/api/CdlBh/IncluirSamPrevidaArta", result)
            .then((response) => {
              if (response.data.sucesso) {
                this.registros[i].cadastrado = true;
              } else if (response.data.erro) {
                this.registros[i].erro = response.data.mensagem;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      this.enviarArquivos();
    },
    prepararDados(campos) {
      var telefone = clearStr(campos.cadastroFinal.telefone);
      var codSocio = localStorage.getItem("associadoSelecionado");

      let dados = {
        //codsocio: this.$store.state.userDetails.dadosCadastraisAssociado[0].codseqsocio,
        cpF_TITULAR: clearStr(this.cpfTitular),
        cpF_DEPENDENTE:
          campos.tipoCadastro == "dependente"
            ? clearStr(campos.cadastroFinal.cpf)
            : "",
        nome: campos.nome,
        datanascimento: campos.dataNascimento,
        email: campos.cadastroFinal.email,
        ddd: telefone.slice(0, 2),
        telefone: telefone.slice(2, 11),
        titularidade: campos.cadastroFinal.tipoDependente,
        sexo: campos.cadastroFinal.sexo,
        estadoCivil: campos.cadastroFinal.estadoCivil,
        mae: campos.cadastroFinal.nomeMae,
        rua: campos.cadastroFinal.rua,
        numero: campos.cadastroFinal.numero,
        bairro: campos.cadastroFinal.bairro,
        cidade: campos.cadastroFinal.cidade,
        uf: campos.cadastroFinal.estado,
        cep: clearStr(campos.cadastroFinal.cep),
        datavigencia: this.dataVigencia,
        codplanofx: campos.plano.codPlano ?? campos.plano.codPlanoFx,
        listaOpcional: campos.opcionais,
        codSocio: codSocio,
      };
      return dados;
    },
    enviarArquivos() {
      var erro = false;
      var mensagem = "";
      this.registros.forEach((v) => {
        if (!v.cadastrado && v.nome) {
          erro = true;
          mensagem += v.erro + " \n";
          return true;
        }
      });

      if (erro) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao cadastrar seus dados. Verifique: \n" + mensagem,
          type: "error",
        });
      } else {
        localStorage.removeItem("cdlsaude_cadastro");
        this.$router.push({
          name: "cdl-saude-arquivos",
          params: { cpfTitular: clearStr(this.cpfTitular) },
        });
      }
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montaDados();
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
.produto-cdlsaude-resumo /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
}
</style>
